//CONSIGNMENT REQUEST
export const CONSIGNMENT_REQUEST_SET = "CONSIGNMENT_REQUEST_SET";
export const CONSIGNMENT_REQUEST_RESET = "CONSIGNMENT_REQUEST_RESET";

//CONSIGNMENT RESULT
export const CONSIGNMENT_RESULT_SET = "CONSIGNMENT_RESULT_SET";
export const CONSIGNMENT_RESULT_RESET = "CONSIGNMENT_RESULT_RESET";

//CLIENT
export const CLIENT_SET = "CLIENT_SET";
export const CLIENT_RESET = "CLIENT_RESET";

//LANGUAGE
export const LANGUAGE_SET = "LANGUAGE_SET";
export const LANGUAGE_RESET = "LANGUAGE_RESET";

//RELOAD
export const RELOAD_SET = "RELOAD_SET";
export const RELOAD_SET_LAST = "RELOAD_SET_LAST";

//FILTER
export const FILTER_SET = "FILTER_SET";
export const FILTER_RESET = "FILTER_RESET";

//SESSION
export const SESSION_SET_DATA = "SESSION_SET_DATA";
export const SESSION_CLEAR = "SESSION_CLEAR";
export const SESSION_LOADING = "SESSION_LOADING";
